module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-classic-5-19ad6bd9832e4a79cb2b5c013733d05d.webp";